const isValidSimNumber = (simNumber) => {
    return /^(89\d{17,18}|\d{13})$/.test(simNumber);
};

export default isValidSimNumber;